import axios from 'axios'

import { reatailmediaApi as baseAPI } from '../../api'

const baseURL = `${baseAPI}/configuration/campaign-permissions`

export const getCampaignPermissionsServiceKey = 'getCampaignPermissions'

export const getCampaignPermissionsService = (
  params: GetCampaignPermissionsRequestParams = {}
) => axios.get<GetCampaignPermissionsResponse>(baseURL, { params })

export const patchCampaignPermissionsService = (
  body: PatchCampaignPermissionsRequestParams
) => axios.patch<PatchCampaignPermissionsResponse>(baseURL, body)
